// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css - Global styles for the application */

body, html, #root {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.leaflet-container {
  height: 100%;
  width: 100%;
}

/* Ensure map takes full height minus header */
.map-container {
  position: absolute;
  top: 57px;
  left: 0;
  height: calc(100vh - 57px);
  width: 100vw;
}

/* Dark Glassmorphism style for headers and main containers */
.glass-pane-dark {
  background: #23242a !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border-radius: 0 !important;
  border: none !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.07) !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  min-height: unset !important;
  height: auto !important;
}

/* Light Glassmorphism style for floating panels */
.glass-pane-light {
  background: rgba(35, 37, 49, 0.7); /* Match Find XY glass */
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.12);
  box-shadow: 0 8px 32px 0 rgba(0,0,0,0.37);
}

.glass-pane-medium {
  background: rgba(35, 37, 49, 0.7); /* Even darker, more opaque glass */
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
}

/* Drag and drop animation */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,0BAA0B;EAC1B,YAAY;AACd;;AAEA,6DAA6D;AAC7D;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;EACvB,iDAAiD;EACjD,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,iCAAiC,EAAE,wBAAwB;EAC3D,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC,EAAE,mCAAmC;EACtE,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA,4BAA4B;AAC5B;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":["/* App.css - Global styles for the application */\n\nbody, html, #root {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.leaflet-container {\n  height: 100%;\n  width: 100%;\n}\n\n/* Ensure map takes full height minus header */\n.map-container {\n  position: absolute;\n  top: 57px;\n  left: 0;\n  height: calc(100vh - 57px);\n  width: 100vw;\n}\n\n/* Dark Glassmorphism style for headers and main containers */\n.glass-pane-dark {\n  background: #23242a !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  border-radius: 0 !important;\n  border: none !important;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.07) !important;\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n  min-height: unset !important;\n  height: auto !important;\n}\n\n/* Light Glassmorphism style for floating panels */\n.glass-pane-light {\n  background: rgba(35, 37, 49, 0.7); /* Match Find XY glass */\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border-radius: 16px;\n  border: 1px solid rgba(255,255,255,0.12);\n  box-shadow: 0 8px 32px 0 rgba(0,0,0,0.37);\n}\n\n.glass-pane-medium {\n  background: rgba(35, 37, 49, 0.7); /* Even darker, more opaque glass */\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);\n}\n\n/* Drag and drop animation */\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 0.9;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
